"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (canvas, opts) {
  return canvas.getContext("webgl", opts) || canvas.getContext("webgl-experimental", opts) || canvas.getContext("experimental-webgl", opts);
};
//# sourceMappingURL=getContext.js.map


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/gl-react-dom/lib/getContext.js
// module id = 928
// module chunks = 0